import type { Routes } from '@angular/router';
import { permissionGuard } from '../../../auth/common/guards/permission.guard';
import { documentsResolver } from './common/resolvers/documents.resolver';

export const DOCUMENTS_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'prefix',
    loadComponent: () =>
      import('./documents/documents.component').then(
        (m) => m.DocumentsComponent,
      ),
    canActivate: [permissionGuard('documents.get')],
    resolve: { documents: documentsResolver },
  },
] as const;
